import {
  initDepthViewOptionsSlice,
  initDepthViewOptionsState,
} from '@skynet/data-liquidity-view-options';

// Both domains default to the shared base set ±1% / ±2% / ±5%. Applies to the
// loans liquidity table and loans tasks; server-sent depths beyond the base
// (e.g. ±0.5%, ±10%) appear as off-by-default toggles in the depth view options.
const initialState = initDepthViewOptionsState({ enabledDepths: ['1', '2', '5'] });

const { reducer, actions } = initDepthViewOptionsSlice({
  sliceName: 'loansDepthViewOptions',
  initialState,
});

export const depthViewOptionsActions = actions;

export default reducer;
